import { render, staticRenderFns } from "./reportImg.vue?vue&type=template&id=2e7b4e8b&"
import script from "./reportImg.vue?vue&type=script&lang=js&"
export * from "./reportImg.vue?vue&type=script&lang=js&"
import style0 from "./reportImg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports